import React, { useState,useEffect } from 'react';
import { Button, Form, FormControl, FormGroup, FormLabel } from 'react-bootstrap';
import {useDispatch} from 'react-redux';
import {createHomePost} from '../../actions/homePagePosts';
import Filebase from 'react-file-base64';
import { TextField, Typography, Paper } from '@material-ui/core';

import './AhomePage.css';
import { GiClawSlashes } from 'react-icons/gi';
import { MdTextFields } from 'react-icons/md';
import {useSelector} from 'react-redux';


function AhomePage(props) {
    const dispatch = useDispatch();
    const Hposts = useSelector((state)=>state.homePost);
   
    


    const [postContent,setPostContent]= useState({
        welcomeBox:{
            title: '',
            content: '',
            video: ''
        },
        aboutBox:{
            ceoImage: '',
            accreditationImg: '',
            content: ''
        },
        room1:{
            name:'',
            image: ''
        },
        room2:{
            name: '',
            image: ''
        },
        room3:{
            name:'',
            image: ''
        },
        testimonials:{
            title:'',
            content: ''
        },
    })
    

    const handleSubmit = (e)=>{
        e.preventDefault()

        dispatch(createHomePost(postContent));
    }  

    return (
        <div>
            {
                
               Hposts.length > 0 ? 
                Hposts.map((elm,_id)=>{
                          
                  return(     
            <div key={_id}  className={props.cond === 'Home Page'?'cardPageHome':'pouf'}>
                   
                <Form>
                    <div className='cardPageHome inner-title-wrapper'>
                        <div className='intro-box'>
                            <h4>INTRO</h4>
                            
                        </div>
                    <FormGroup className="mb-3">
                        <FormLabel>Welcome Title</FormLabel>
                        <FormControl type='text' name='welcomeBoxTitle'   defaultValue={ elm.welcomeBox.title} onChange={e => setPostContent({...postContent,welcomeBox:{...postContent.welcomeBox,title:e.target.value}})} />
                     </FormGroup>
                    <FormGroup className="mb-3">
                        {/* <p>{postContent.welcomeBox.title}</p> */}
                        <Form.Label>Welcome Message</Form.Label>
                        <Form.Control as="textarea" name='welcomeBoxContent' defaultValue={elm.welcomeBox.content} rows={3} onChange={(e)=>setPostContent({...postContent,welcomeBox:{...postContent.welcomeBox,content:e.target.value}})} />
                    </FormGroup>
                    
                        <Form.Group controlId="formFileSm" className="mb-3">
                            <Form.Label>Upload Intro Video </Form.Label>
                            <Form.Control type="file" size="sm" name='welcomeBoxVideo' value={postContent.welcomeBox.video} onChange={(e)=>setPostContent({...postContent,welcomeBox:{...postContent.welcomeBox,video:e.target.value}})} />
                        </Form.Group>
                    </div>
                    <div className='cardPageHome inner-title-wrapper'>
                            <div className='intro-box'>
                                <h4>ABOUT US</h4>
                            </div>
                        <Form.Group controlId="formFileSm" className="mb-3">
                            <Form.Label>Enter CEO Photo</Form.Label>
                            {/* <Form.Control type="file" name='aboutBoxCeoImg' value={postContent.aboutBox.ceoImage} size="sm" onChange={(e)=>setPostContent({...postContent,aboutBox:{...postContent.aboutBox,ceoImage:e.target.value}})} /> */}
                            <div  className='fileInput'>
                            <Filebase 
                                type='file'
                                multiple={false}
                                onDone={({base64})=> setPostContent({...postContent,aboutBox:{...postContent.aboutBox,ceoImage:base64}})}
                            />
                            </div>
                           
                        </Form.Group>
                        <Form.Group controlId="formFileSm" className="mb-3">
                            <Form.Label>Enter Accreditation Photo</Form.Label>
                            {/* <Form.Control type="file" size="sm" name='aboutBoxAccreditationImg' value={postContent.aboutBox.accreditationImg} onChange={(e)=>setPostContent({...postContent,aboutBox:{...postContent.aboutBox,accreditationImg:e.target.value}})} /> */}
                            <div  className='fileInput'>
                            <Filebase 
                                type='file'
                                multiple={false}
                                onDone={({base64})=> setPostContent({...postContent,aboutBox:{...postContent.aboutBox,accreditationImg:base64}})}
                            />
                            </div>
                        </Form.Group>
                        {/* <TextField name="message" variant="outlined" label="Message" fullWidth multiline rows={4} value={postContent.aboutBox.content} onChange={(e) => setPostContent({...postContent,aboutBox:{...postContent.aboutBox,content:e.target.value}})} /> */}
                        <FormGroup className="mb-3">
                            <Form.Label>Content</Form.Label>
                            <Form.Control as="textarea" rows={5} name='aboutBoxContent' value={postContent.aboutBox.content} onChange={(e)=>setPostContent({...postContent,aboutBox:{...postContent.aboutBox,content:e.target.value}})} />
                        </FormGroup>
                    </div>
                    <div className='cardPageHome inner-title-wrapper'>
                        <div className='intro-box'>
                            <h4>ROOM TYPES</h4>
                        </div>
                        <FormGroup className="mb-3">
                            <FormLabel>Room1 Name</FormLabel>
                            <FormControl type='text' name='room1Name' value={postContent.room1.name} onChange={(e)=>setPostContent({...postContent,room1:{...postContent.room1,name:e.target.value}})} />
                        </FormGroup>
                        <Form.Group controlId="formFileSm" className="mb-3">
                            <Form.Label>Upload Room1 Photo </Form.Label>
                            {/* <Form.Control type="file" name='room1Image' size="sm" value={postContent.room1.image} onChange={(e)=>setPostContent({...postContent,room1:{...postContent.room1,image:e.target.value}})} /> */}
                            <div  className='fileInput'>
                            <Filebase 
                                type='file'
                                multiple={false}
                                onDone={({base64})=> setPostContent({...postContent,room1:{...postContent.room1,image:base64}})}
                            />
                            </div>
                        </Form.Group>
                        <FormGroup className="mb-3">
                            <FormLabel>Room2 Name</FormLabel>
                            <FormControl type='text' name='room2Name' value={postContent.room2.name} onChange={(e)=>setPostContent({...postContent,room2:{...postContent.room2,name:e.target.value}})} />
                        </FormGroup>
                        <Form.Group controlId="formFileSm" className="mb-3">
                            <Form.Label>Upload Room2 Photo </Form.Label>
                            {/* <Form.Control type="file" size="sm" name='room2Image' value={postContent.room2.image} onChange={(e)=>setPostContent({...postContent,room2:{...postContent.room2,image:e.target.value}})} /> */}
                            <div  className='fileInput'>
                            <Filebase 
                                type='file'
                                multiple={false}
                                onDone={({base64})=> setPostContent({...postContent,room2:{...postContent.room2,image:base64}})}
                            />
                            </div>
                        </Form.Group>
                        <FormGroup className="mb-3">
                            <FormLabel>Room3 Name</FormLabel>
                            <FormControl type='text' name='room3Name' value={postContent.room3.name} onChange={(e)=>setPostContent({...postContent,room3:{...postContent.room3,name:e.target.value}})} />
                        </FormGroup>
                        <Form.Group controlId="formFileSm" className="mb-3">
                            <Form.Label>Upload Room3 Photo </Form.Label>
                            {/* <Form.Control type="file" size="sm" name='room3Image' value={postContent.room3.image} onChange={(e)=>setPostContent({...postContent,room3:{...postContent.room3,image:e.target.value}})} /> */}
                            <div  className='fileInput'>
                            <Filebase 
                                type='file'
                                multiple={false}
                                onDone={({base64})=> setPostContent({...postContent,room3:{...postContent.room3,image:base64}})}
                            />
                            </div>
                        </Form.Group>
                    </div>
                    <div className='cardPageHome inner-title-wrapper'>
                        <div className='intro-box'>
                            <h4>TESTIMONIALS</h4>
                        </div>
                        <FormGroup className="mb-3">
                            <FormLabel>Testimonial Title</FormLabel>
                            <FormControl type='text' name='testimonialTitle' value={postContent.testimonials.title} onChange={(e)=>setPostContent({...postContent,testimonials:{...postContent.testimonials,title:e.target.value}})} />
                        </FormGroup>
                        <FormGroup className="mb-3">
                            <Form.Label>Testimonial Message</Form.Label>
                            <Form.Control as="textarea" rows={3} name='testimonialContent' value={postContent.testimonials.content} onChange={(e)=>setPostContent({...postContent,testimonials:{...postContent.testimonials,content:e.target.value}})} />
                        </FormGroup>
                    </div>
                    <div className='intro-box'>
                        <Button variant='secondary' type='submit' onClick={handleSubmit}>UPDATE</Button>
                    </div>
                </Form>
            </div>
            )
        }):
        <div   className={props.cond === 'Home Page'?'cardPageHome':'pouf'}>
                   
                   <Form>
                       <div className='cardPageHome inner-title-wrapper'>
                           <div className='intro-box'>
                               <h4>INTRO</h4>
                           </div>
                       <FormGroup className="mb-3">
                           <FormLabel>Welcome Title</FormLabel>
                           <FormControl type='text' name='welcomeBoxTitle'   defaultValue={postContent.welcomeBox.title} onChange={e => setPostContent({...postContent,welcomeBox:{...postContent.welcomeBox,title:e.target.value}})} />
                        </FormGroup>
                       <FormGroup className="mb-3">
                           <p>{postContent.welcomeBox.title}</p>
                           <Form.Label>Welcome Message</Form.Label>
                           <Form.Control as="textarea" name='welcomeBoxContent' defaultValue={postContent.welcomeBox.content} rows={3} onChange={(e)=>setPostContent({...postContent,welcomeBox:{...postContent.welcomeBox,content:e.target.value}})} />
                       </FormGroup>
                       
                           <Form.Group controlId="formFileSm" className="mb-3">
                               <Form.Label>Upload Intro Video </Form.Label>
                               <Form.Control type="file" size="sm" name='welcomeBoxVideo' value={postContent.welcomeBox.video} onChange={(e)=>setPostContent({...postContent,welcomeBox:{...postContent.welcomeBox,video:e.target.value}})} />
                           </Form.Group>
                       </div>
                       <div className='cardPageHome inner-title-wrapper'>
                               <div className='intro-box'>
                                   <h4>ABOUT US</h4>
                               </div>
                           <Form.Group controlId="formFileSm" className="mb-3">
                               <Form.Label>Enter CEO Photo</Form.Label>
                               {/* <Form.Control type="file" name='aboutBoxCeoImg' value={postContent.aboutBox.ceoImage} size="sm" onChange={(e)=>setPostContent({...postContent,aboutBox:{...postContent.aboutBox,ceoImage:e.target.value}})} /> */}
                               <div  className='fileInput'>
                               <Filebase 
                                   type='file'
                                   multiple={false}
                                   onDone={({base64})=> setPostContent({...postContent,aboutBox:{...postContent.aboutBox,ceoImage:base64}})}
                               />
                               </div>
                              
                           </Form.Group>
                           <Form.Group controlId="formFileSm" className="mb-3">
                               <Form.Label>Enter Accreditation Photo</Form.Label>
                               {/* <Form.Control type="file" size="sm" name='aboutBoxAccreditationImg' value={postContent.aboutBox.accreditationImg} onChange={(e)=>setPostContent({...postContent,aboutBox:{...postContent.aboutBox,accreditationImg:e.target.value}})} /> */}
                               <div  className='fileInput'>
                               <Filebase 
                                   type='file'
                                   multiple={false}
                                   onDone={({base64})=> setPostContent({...postContent,aboutBox:{...postContent.aboutBox,accreditationImg:base64}})}
                               />
                               </div>
                           </Form.Group>
                           {/* <TextField name="message" variant="outlined" label="Message" fullWidth multiline rows={4} value={postContent.aboutBox.content} onChange={(e) => setPostContent({...postContent,aboutBox:{...postContent.aboutBox,content:e.target.value}})} /> */}
                           <FormGroup className="mb-3">
                               <Form.Label>Content</Form.Label>
                               <Form.Control as="textarea" rows={5} name='aboutBoxContent' value={postContent.aboutBox.content} onChange={(e)=>setPostContent({...postContent,aboutBox:{...postContent.aboutBox,content:e.target.value}})} />
                           </FormGroup>
                       </div>
                       <div className='cardPageHome inner-title-wrapper'>
                           <div className='intro-box'>
                               <h4>ROOM TYPES</h4>
                           </div>
                           <FormGroup className="mb-3">
                               <FormLabel>Room1 Name</FormLabel>
                               <FormControl type='text' name='room1Name' value={postContent.room1.name} onChange={(e)=>setPostContent({...postContent,room1:{...postContent.room1,name:e.target.value}})} />
                           </FormGroup>
                           <Form.Group controlId="formFileSm" className="mb-3">
                               <Form.Label>Upload Room1 Photo </Form.Label>
                               {/* <Form.Control type="file" name='room1Image' size="sm" value={postContent.room1.image} onChange={(e)=>setPostContent({...postContent,room1:{...postContent.room1,image:e.target.value}})} /> */}
                               <div  className='fileInput'>
                               <Filebase 
                                   type='file'
                                   multiple={false}
                                   onDone={({base64})=> setPostContent({...postContent,room1:{...postContent.room1,image:base64}})}
                               />
                               </div>
                           </Form.Group>
                           <FormGroup className="mb-3">
                               <FormLabel>Room2 Name</FormLabel>
                               <FormControl type='text' name='room2Name' value={postContent.room2.name} onChange={(e)=>setPostContent({...postContent,room2:{...postContent.room2,name:e.target.value}})} />
                           </FormGroup>
                           <Form.Group controlId="formFileSm" className="mb-3">
                               <Form.Label>Upload Room2 Photo </Form.Label>
                               {/* <Form.Control type="file" size="sm" name='room2Image' value={postContent.room2.image} onChange={(e)=>setPostContent({...postContent,room2:{...postContent.room2,image:e.target.value}})} /> */}
                               <div  className='fileInput'>
                               <Filebase 
                                   type='file'
                                   multiple={false}
                                   onDone={({base64})=> setPostContent({...postContent,room2:{...postContent.room2,image:base64}})}
                               />
                               </div>
                           </Form.Group>
                           <FormGroup className="mb-3">
                               <FormLabel>Room3 Name</FormLabel>
                               <FormControl type='text' name='room3Name' value={postContent.room3.name} onChange={(e)=>setPostContent({...postContent,room3:{...postContent.room3,name:e.target.value}})} />
                           </FormGroup>
                           <Form.Group controlId="formFileSm" className="mb-3">
                               <Form.Label>Upload Room3 Photo </Form.Label>
                               {/* <Form.Control type="file" size="sm" name='room3Image' value={postContent.room3.image} onChange={(e)=>setPostContent({...postContent,room3:{...postContent.room3,image:e.target.value}})} /> */}
                               <div  className='fileInput'>
                               <Filebase 
                                   type='file'
                                   multiple={false}
                                   onDone={({base64})=> setPostContent({...postContent,room3:{...postContent.room3,image:base64}})}
                               />
                               </div>
                           </Form.Group>
                       </div>
                       <div className='cardPageHome inner-title-wrapper'>
                           <div className='intro-box'>
                               <h4>TESTIMONIALS</h4>
                           </div>
                           <FormGroup className="mb-3">
                               <FormLabel>Testimonial Title</FormLabel>
                               <FormControl type='text' name='testimonialTitle' value={postContent.testimonials.title} onChange={(e)=>setPostContent({...postContent,testimonials:{...postContent.testimonials,title:e.target.value}})} />
                           </FormGroup>
                           <FormGroup className="mb-3">
                               <Form.Label>Testimonial Message</Form.Label>
                               <Form.Control as="textarea" rows={3} name='testimonialContent' value={postContent.testimonials.content} onChange={(e)=>setPostContent({...postContent,testimonials:{...postContent.testimonials,content:e.target.value}})} />
                           </FormGroup>
                       </div>
                       <div className='intro-box'>
                           <Button variant='secondary' type='submit' onClick={handleSubmit}>UPDATE</Button>
                       </div>
                   </Form>
               </div>
        
        }
        </div>
    )
}

export default AhomePage